import { defineStore } from 'pinia'
import type { MyGeneratedMusicItem } from '~/types/generate'

export const useMusicPreviewStore = defineStore('MusicPreviewStore', () => {
  const previewSong = ref<MyGeneratedMusicItem | null>(null)

  const setPreviewSong = (song: MyGeneratedMusicItem | null) => {
    previewSong.value = song
  }

  const clearPreviewSong = () => {
    previewSong.value = null
  }

  return {
    previewSong,
    setPreviewSong,
    clearPreviewSong
  }
})
